const actions = {
  CREATE_EXTERNAL_CODE_GENERATOR: 'CREATE_EXTERNAL_CODE_GENERATOR',
  CREATE_EXTERNAL_CODE_GENERATOR_ENDED: 'CREATE_EXTERNAL_CODE_GENERATOR_ENDED',
  SEARCH_EXTERNAL_CODE_GENERATORS: 'SEARCH_EXTERNAL_CODE_GENERATORS',
  SEARCH_EXTERNAL_CODE_GENERATORS_ENDED: 'SEARCH_EXTERNAL_CODE_GENERATORS_ENDED',
  UPDATE_EXTERNAL_CODE_GENERATOR: 'UPDATE_EXTERNAL_CODE_GENERATOR',
  UPDATE_EXTERNAL_CODE_GENERATOR_ENDED: 'UPDATE_EXTERNAL_CODE_GENERATOR_ENDED',
  DELETE_EXTERNAL_CODE_GENERATOR: 'DELETE_EXTERNAL_CODE_GENERATOR',
  DELETE_EXTERNAL_CODE_GENERATOR_ENDED: 'DELETE_EXTERNAL_CODE_GENERATOR_ENDED',
  SEARCH_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS: 'SEARCH_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS',
  SEARCH_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS_ENDED:
    'SEARCH_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS_ENDED',
  UPDATE_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS: 'UPDATE_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS',
  UPDATE_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS_ENDED:
    'UPDATE_EXTERNAL_CODE_GENERATOR_BRAND_FIELDS_ENDED',
};

export default actions;
